import { connect } from 'react-redux'
import AvatarUser from './presentational'

const mapStateToProps = (state) => ({
  firstname: state.profile.payload.firstname || ' ',
  lastname: state.profile.payload.lastname || ' ',
})

export default connect(mapStateToProps)(AvatarUser)
